module.exports = __webpack_public_path__ + "static/media/communications2.75b2d8b8.png";